import React, { useState } from "react";
import {
  Dialog,
  ListItem,
  List,
  Toolbar,
  Slide,
  Grid,
  DialogTitle,
  Checkbox,
} from "@material-ui/core";
import { TransitionProps } from "@material-ui/core/transitions";
import { ButtonSubmit } from "../../../../../Components";
import { TextField2 } from "../../../../../Components/Field";
import { useStyles } from "./DocumentGroup.style";
import { useIntl } from "react-intl";
import { SelectCheck } from "../../../../../Components/Select/SelectCheck";
import { useDispatch, useSelector } from "react-redux";
import DocumentGroupServices from "../../../../../Redux/Actions/DocumentGroup/DocumentGroupAction";
import { useApiValidationSnackbar } from "../../../../../Components/Snackbar/SnackbarAlert";
import { useNavigate } from "react-router-dom";
import { useSnackbar } from "notistack";
import DropDownItem from "../DropDownItem";
const Transition = React.forwardRef(function Transition(
  props: TransitionProps & { children?: React.ReactElement },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});
interface createGrpupProps {
  handleClose: () => void;
  open: boolean;
  addUserClose?: () => void;
  addopen?: any;
  group: any;
  data: any;
  forceReload: () => void;
  setReload: () => void;
  hierarchicalDocumentFunction: () => void;
  documentData?: any;
}
export const CreateDocument = ({
  handleClose,
  open,
  addUserClose,
  addopen,
  group,
  data,
  forceReload,
  setReload,
  hierarchicalDocumentFunction,
  documentData,
}: createGrpupProps) => {
  let { userList, apiToken, currentUser } = useSelector((state: any) => ({
    userList: state?.UserReducer?.userList,
    apiToken: state?.UserReducer?.apiToken,
    currentUser: state?.UserReducer?.currentUser,
  }));
  const [input, setInput] = useState({ name: "", descrioption: "" });
  const [selectValue, setSelectValue] = useState({ id: "" });
  const { formatMessage } = useIntl();
  const classes = useStyles();
  const dispatch: any = useDispatch();
  const navigate = useNavigate();
  let { ErrorMessage } = useApiValidationSnackbar();
  const { enqueueSnackbar } = useSnackbar();
  let [checked, setChecked] = React.useState(false);
  const handleChange = (event: any) => {
    setChecked(event.target.checked);
  };
  const CreateDocumentGroup = () => {
    const userParam = {
      name: input?.name,
      description: input?.descrioption,
      customerId: currentUser?.customerId,
      parentId: selectValue?.id || null,
      restrictUploads: checked,
    };
    let fileName: any = "fillgroupName";
    let description: any = "description";
    if (!input.name) {
      ErrorMessage(userList, fileName);
    } else if (!input.descrioption) {
      ErrorMessage(userList, description);
    } else {
      dispatch(
        DocumentGroupServices?.createDocumentGroup(
          userParam,
          apiToken,
          enqueueSnackbar
        )
      );
      setReload();
      setTimeout(() => {
        hierarchicalDocumentFunction();
        dispatch(
          DocumentGroupServices?.allDocumentGroups(
            currentUser?.customerId,
            apiToken
          )
        );
      }, 1500);
      documentData?.documents == "document"
        ? handleClose()
        : navigate("/ms/administrations/folder");
    }
  };

  return (
    <div>
      <Dialog
        open={open}
        onClose={handleClose}
        TransitionComponent={Transition}
      >
        <DialogTitle id="alert-dialog-title">
          {formatMessage({
            id: "group.user.createDocument",
            defaultMessage: "Group Name",
          })}
        </DialogTitle>
        <List>
          <ListItem>
            <Grid style={{ marginLeft: 7 }}>
              <Grid container spacing={2}>
                <Grid item xs={6}>
                  <TextField2
                    onChange={(str: string) =>
                      setInput({ ...input, name: str })
                    }
                    placeholder={formatMessage({
                      id: "group.user.groupName",
                      defaultMessage: "Group Name",
                    })}
                    Textlabel="group.user.groupName"
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField2
                    onChange={(str: string) =>
                      setInput({ ...input, descrioption: str })
                    }
                    placeholder={formatMessage({
                      id: "group.user.description",
                      defaultMessage: "Group Description",
                    })}
                    Textlabel="group.user.description"
                  />
                </Grid>
              </Grid>
              <Grid
                container
                alignItems="center"
                className={classes.marginTop10}
              >
                {data?.length ? (
                  <Grid
                    item
                    xs={6}
                    style={{ paddingRight: "10px" }}
                    className="dropdownItemField"
                  >
                    <DropDownItem
                      data={data}
                      restrict={checked}
                      handleChange={(val) => setSelectValue(val)}
                      selectValue={selectValue}
                    />
                  </Grid>
                ) : (
                  ""
                )}
                <Grid item xs={6} className={classes.g_name}>
                  &nbsp;{" "}
                  {formatMessage({
                    id: "group.user.restrict",
                    defaultMessage: "Restrict document upload",
                  })}
                  <Checkbox
                    checked={checked}
                    onChange={handleChange}
                    inputProps={{ "aria-label": "primary checkbox" }}
                    className="ml-2"
                  />
                </Grid>
              </Grid>
            </Grid>
          </ListItem>
        </List>
        <Toolbar>
          <ButtonSubmit
            text={"model.title.cancel"}
            onClick={handleClose}
            className={classes.padding5}
          />
          <Grid container justifyContent={"flex-end"}>
            <ButtonSubmit
              text={"component.mtable.save"}
              onClick={CreateDocumentGroup}
            />
          </Grid>
        </Toolbar>
      </Dialog>
      <Dialog
        open={addopen}
        onClose={addUserClose}
        TransitionComponent={Transition}
      >
        <DialogTitle id="alert-dialog-title" style={{ width: 320 }}>
          {formatMessage({
            id: "group.user.save",
            defaultMessage: "Add User Document",
          })}{" "}
          &nbsp;{group?.name}
        </DialogTitle>
        <List>
          <ListItem>
            <SelectCheck
              onChange={(e: any, newMember: any) =>
                console.log(newMember, "add Document")
              }
              options={userList}
            />
          </ListItem>
        </List>
        <Toolbar>
          <ButtonSubmit
            text={"model.title.cancel"}
            onClick={addUserClose}
            className={classes.padding5}
          />
          <Grid container justifyContent={"flex-end"}>
            <ButtonSubmit text={"model.title.save"} onClick={addUserClose} />
          </Grid>
        </Toolbar>
      </Dialog>
    </div>
  );
};
